import moment from 'moment';

const INPUT_FORMATS = [
  moment.ISO_8601,
  'YYYY-MM-DD HH:mm:ss.S',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DDTHH:mm',
  'YYYY-MM-DD',
  'DD-MM-YYYY HH:mm:ss',
  'DD-MM-YYYY',
  'DD/MM/YYYY',
];

/** Parse the many date shapes the API returns; null when empty/invalid. */
export const parseDate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date || moment.isMoment(value)) return moment(value);
  let m = moment(String(value), INPUT_FORMATS, true);
  if (!m.isValid()) m = moment(String(value));
  return m.isValid() ? m : null;
};

/** 28th Aug 2026 */
export const formatDate = (value, fallback = '—') => {
  const m = parseDate(value);
  return m ? m.format('Do MMM YYYY') : fallback;
};

/** 28th Aug 2026 - 2:06pm */
export const formatDateTime = (value, fallback = '—') => {
  const m = parseDate(value);
  return m ? m.format('Do MMM YYYY - h:mma') : fallback;
};

/** Whole years between the date and today; null when unknown. */
export const ageInYears = (value) => {
  const m = parseDate(value);
  return m ? moment().diff(m, 'years') : null;
};
